import { render, staticRenderFns } from "./ChannelCustomCredentialsCmp.vue?vue&type=template&id=37b30e26&scoped=true&"
import script from "./ChannelCustomCredentialsCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelCustomCredentialsCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCustomCredentialsCmp.vue?vue&type=style&index=0&id=37b30e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b30e26",
  null
  
)

export default component.exports